<template lang="html">
<div v-if="wsDebug">
  <div class="messagebox">
    <label for="message"> Enter a message:
      <input ref="inputBox"
             placeholder="Type something"
             v-model="inputBoxData"
             :disabled=!isConnected>
    </label>
    <button v-on:click="sendChatMessage(inputBoxData)"
            :disabled=!isConnected>
      Send
    </button>
  </div>
  <ul>
    <li>URL: <code>{{ url }}</code></li>
    <li>Connected: <code>{{ isConnected }}</code></li>
    <li>Message: <code>{{ message }}</code></li>
    <li>Socket error: <code>{{ socketError }}</code></li>
    <li>Reconnect count: <code>{{ reconnectCount }}</code></li>
    <li>Reconnect error: <code>{{ reconnectError }}</code></li>
    <li>Channel name: <code>{{ channelName }}</code></li>
  </ul>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { MMCC_CHAT_MESSAGE } from '@/utils/mmccMessageTypes.js'

export default {
  props: {
    wsConsumer: {
      type: String,
      required: true
    },
    wsDebug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      inputBoxData: 'hello'
    }
  },
  methods: {
    sendChatMessage (message) {
      this.$socket.sendObj(
        {
          type: MMCC_CHAT_MESSAGE,
          message: message
        })
    }
  },
  computed: {
    url () {
      // This is reactive because dependant on another computed property.
      if (this.isConnected) {
        return this.$socket.url
      } else {
        return ''
      }
    },
    ...mapState({
      // Map all websocket state.
      isConnected: state => state.websocket.isConnected,
      message: state => state.websocket.message,
      socketError: state => state.websocket.error,
      reconnectCount: state => state.websocket.reconnectCount,
      reconnectError: state => state.websocket.reconnectError,
      channelName: state => state.websocket.channelName
    })
  },
  mounted () {
    // Automatically connect when this component is mounted.
    this.$connect(process.env.VUE_APP_WS_URL + '/' + this.wsConsumer)
  },
  beforeDestroy () {
    // Disconnect when this component is destroyed.
    this.$disconnect()
  }
}
</script>
